import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Icon5 from "../../assest/images/Icon5.png";
import { ToastContainer, toast } from "react-toastify";
import config from "../../envconfig";
import CustomDropdown from "../common/CustomDropdown";
import StatusCustomDropdown from "../common/StatusCustomDropdown";
import { UserContext } from "../common/UserContext";
import Select from "react-select";
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';

function SCPMaster() {
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
  } = useContext(UserContext);

  const [formdata, setFormdata] = useState({
    SCPM_Name: "",
    SCPM_Caption: "",
    SCPM_Code: "",
    SCPM_SCPConfig_ID: "",
    SCPM_Status: 1,
    SCPM_ScanningMode: "",
    SCPMO_OutwardParty: "",
    SCPMSL_SameLevelParty: "",
    SCPM_CompanyGrpID: UM_CompanyGrpID,
    SCPM_CompanyID: UM_CompanyID,
  });
  const [message, setMessage] = useState("");

  const [SCPLevelNo, setSCPLevelNo] = useState([]);
  const [scpLevelNames, setscpLevelNames] = useState([]);
  const [outwardscps, setoutwardscps] = useState([]);
  const [samelevel, setsamelevel] = useState([]);
  const [level, setlevel] = useState();
  const [scps, setScps] = useState([]);
  const [op_scps, setOP_Scps] = useState([]);
  const [selectedScps, setSelectedScps] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [submittedSLP, setSubmittedSLP] = useState(false);
  // const [outwardPartyDisabled, setOutwardPartyDisabled] = useState(false);
  const [isAddClicked, setIsAddClicked] = useState(false); // New state variable
  const [isAddClickedSLP, setIsAddClickedSLP] = useState(false); // New state variable
  const [selectedSameLevelParties, setSelectedSameLevelParties] = useState([]);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [onConfirmAction, setOnConfirmAction] = useState(null);
  const [scanningModeOptions, setScanningModeOptions] = useState([]);
  const [scanningModeLoading, setScanningModeLoading] = useState(false);
  const initialData = {
    SCPM_Name: "",
    SCPM_Caption: "",
    SCPM_Code: "",
    SCPM_SCPConfig_ID: "",
    SCPM_Status: "",
    SCPMO_OutwardParty: "",
    SCPMSL_SameLevelParty: "",
    SCPM_ScanningMode: "",
  };
  const [errors, setErrors] = useState({
    required: initialData,
    other: initialData,
    addButton: "", // New error state for the add button
  });
  // State to store SCP AllowMutlipleParty values
  const [scpAllowMutlipleParty, setScpAllowMutlipleParty] = useState({
    SCP_AllowMutliplePartySameLevelOutward: "",
    SCP_AllowMutliplePartyOutward: "",
  });
  // Add these state variables to track disabled SCP IDs
  const [disabledOutwardScps, setDisabledOutwardScps] = useState([]);
  const [disabledSameLevelScps, setDisabledSameLevelScps] = useState([]);
  // Add these new state variables to track working selections (before ADD is clicked)
  const [workingSelectedScps, setWorkingSelectedScps] = useState([]);
  const [workingSelectedSameLevelParties, setWorkingSelectedSameLevelParties] = useState([]);
  const [isSelectOpen, setIsSelectOpen] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };
  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };





  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);

    sessionStorage.setItem("selectedScpId", selectedScpId);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
  ]);
  // Audit Trail
  const audittransection = async (data) => {
    const formData = {
      AUTRN_ID: data.AUTRN_ID,
      AUTRN_OldValue: data.AUTR_NewValue ?? null,
      AUTRN_NewValue: data.AUTRN_NewValue,
      AUTRN_ParamererName: data.AUTRN_ParamererName,
    };
    try {
      const response = await axios.post(
        `${config.API_URL}/api/audittransaction`,
        formData
      );
      // alert('Data inserted successfully.');
    } catch (error) {
      if (error.response) {
        // Server responded with a status other than 2xx
        console.error("Server responded with an error:", error.response.data);
        // alert(`Error: ${error.response.status} - ${error.response.data}`);
      } else if (error.request) {
        // No response received from server
        console.error("No response received:", error.request);
        // alert('Error: No response received from server');
      } else {
        // Other errors
        console.error("Error setting up the request:", error.message);
        // alert('Error: Request setup failed');
      }
    }
  };

  const audittrailpost = async (details) => {
    const getCurrentTimestamp = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // months are zero-indexed
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTimestamp = getCurrentTimestamp();
    const AUTR_OldValue = details?.AUTR_OldValue ?? null;
    const AUTR_NewValue = details?.AUTR_NewValue ?? null;
    const AUTR_Message = details.AUTR_Message;
    const AUTR_AuditType = details.AUTR_AuditType;
    if (
      UM_CompanyID === null ||
      UM_CompanyID === "null" ||
      UM_CompanyGrpID === null ||
      UM_CompanyGrpID === "null" ||
      selectedScpId === null ||
      selectedScpId === "null"
    ) {
      console.log("null--------");
      const data = {
        AUTR_ScreenName: "User Master",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: null,
        AUTR_CompanyGrpId: null,
        AUTR_CompanyID: null,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp,
      };
      console.log(data);
      try {
        const response = await axios.post(
          `${config.API_URL}/api/audittrail`,
          data
        );
        console.log("Success:", response.data);
        return response.data;
      } catch (error) {
        console.error("Error:", error);
      }
    } else {
      console.log("null--------");
      const data = {
        AUTR_ScreenName: "SCP Master",
        AUTR_OldValue: AUTR_OldValue,
        AUTR_NewValue: AUTR_NewValue,
        AUTR_Message: AUTR_Message,
        AUTR_UserID: UM_UserId,
        AUTR_UserName: UM_UserCode,
        AUTR_TimeStamp: currentTimestamp,
        AUTR_AuditType: AUTR_AuditType,
        AUTR_SCPID: selectedScpId,
        AUTR_CompanyGrpId: UM_CompanyID,
        AUTR_CompanyID: UM_CompanyID,
        AUTR_CreatedBy: UM_UserId,
        AUTR_CreatedDateTime: currentTimestamp,
      };
      console.log(data);
      try {
        const response = await axios.post(
          `${config.API_URL}/api/audittrail`,
          data
        );
        console.log("Success:", response.data);
        return response.data;
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  // Fetch scanning mode options from API
  useEffect(() => {
    const fetchScanningMode = async () => {
      // Only fetch if company ID is available
      if (!UM_CompanyID || UM_CompanyID === "null") {
        return;
      }

      setScanningModeLoading(true);
      try {
        const response = await axios.get(
          `${config.API_URL}/scanning-mode/${UM_CompanyID}`
        );

        if (response.status === 200) {
          let options = [];

          // Handle both array and single object responses from API
          if (Array.isArray(response.data)) {
            // Multiple options (scanningMode = 3)
            options = response.data.map(item => ({
              value: item.EnumVal.toString(),
              label: item.Description
            }));

            // Sort options to ensure Vendor (1) comes before Product (2)
            options.sort((a, b) => parseInt(a.value) - parseInt(b.value));

            // If there's only one option, auto-select it
            if (options.length === 1 && !formdata.SCPM_ScanningMode) {
              // Single option: auto-select it
              setFormdata(prev => ({
                ...prev,
                SCPM_ScanningMode: options[0].value
              }));
            } else if (options.length === 2 && !formdata.SCPM_ScanningMode) {
              // Two options: keep it blank (don't auto-select)
              // Do nothing - leave it as empty string
            }
          } else if (response.data && response.data.EnumVal) {
            // Single option
            options = [{
              value: response.data.EnumVal.toString(),
              label: response.data.Description
            }];

            // If only one option is available, select it by default
            if (!formdata.SCPM_ScanningMode) {
              setFormdata(prev => ({
                ...prev,
                SCPM_ScanningMode: options[0].value
              }));
            }
          }

          setScanningModeOptions(options);
        } else {
          // If API fails, use fallback options
          setScanningModeOptions(defaultScanningModeOptions);
        }
      } catch (error) {
        console.error("Failed to fetch scanning mode:", error);
        showToast('error', "Failed to load scanning mode options");

        // Fallback to default options
        setScanningModeOptions(defaultScanningModeOptions);
      } finally {
        setScanningModeLoading(false);
      }
    };

    fetchScanningMode();
  }, [UM_CompanyID]); // Re-fetch when company ID changes
  // Status options for react-select
  const statusOptions = [
    { value: 1, label: "Active" },
    { value: 2, label: "Inactive" },
  ];

  // Default scanning mode options
  const defaultScanningModeOptions = [
    { value: "1", label: "Vendor" },
    { value: "2", label: "Product" },
  ];
  useEffect(() => {
    const fetchSCPAllowMutlipleParty = async () => {
      try {
        const response = await axios.get(
          `${config.API_URL}/SL_ML_OP/${UM_CompanyGrpID}/${formdata.SCPM_SCPConfig_ID}`
        );
        const data = response.data;
        if (response.status === 200) {
          setScpAllowMutlipleParty(data);
          logAction(
            "fetchSCPAllowMutlipleParty():data get from API according to yes and no. "
          );
        } else {
          showToast('error',
            "Error fetching SCP AllowMutlipleParty data according to yes and no.."
          );
          logAction(
            "fetchSCPAllowMutlipleParty():Error fetching SCP AllowMutlipleParty data. Server returned ",
            true
          );
          console.error(
            "Error fetching SCP AllowMutlipleParty data. Server returned:",
            response.status
          );
        }
      } catch (error) {
        showToast('error',
          "Error fetching SCP AllowMutlipleParty data according to yes and no.."
        );
        logAction(
          "fetchSCPAllowMutlipleParty(): Failed to fetch SCP AllowMutlipleParty data ",
          true
        );
        console.error("Failed to fetch SCP AllowMutlipleParty data:", error);
      }
    };
    if (formdata.SCPM_SCPConfig_ID !== "") {
      fetchSCPAllowMutlipleParty();
    }
  }, [UM_CompanyGrpID, formdata.SCPM_SCPConfig_ID]);

  useEffect(() => {
    const fetchScpsByLevelNo = async () => {
      try {
        // Fetch SCPM names based on the selected SCPM Level Number
        const response = await axios.get(
          `${config.API_URL}/SCPM_SLP/${UM_CompanyGrpID}/${formdata.SCPM_SCPConfig_ID}`
        );
        const data = response.data;

        if (response.status === 200) {
          if (data.SCPM_Names) {
            // Update to SCPM_Names
            setScps(data.SCPM_Names); // Update to SCPM_Names
            logAction(
              "fetchScpsByLevelNo(): Get SCP same level name data from API "
            );
          } else {
            showToast('error',
              "Failed to fetch SCP Same Level data. Please check your network connection."
            );
            console.error("Invalid SCP API response:", data);
            logAction(
              "fetchScpsByLevelNo(): Invalid API response. Please check the server logs.",
              true
            );
            // setMessage('Invalid SCP API response. Please check the server logs.');
          }
        } else {
          console.error(
            "Error fetching SCP data. Server returned:",
            response.status
          );
          showToast('error',
            "Failed to fetch SCP Same Level data. Please check your network connection."
          );
          logAction(
            "fetchScpsByLevelNo(): Error fetching SCP data. Please try again.",
            true
          );
          // setMessage('Error fetching SCP data. Please try again.');
        }
      } catch (error) {
        console.error("Failed to fetch SCP data:", error);
        showToast('error',
          "Failed to fetch SCP Same Level data. Please check your network connection."
        );
        logAction(
          "fetchScpsByLevelNo(): Failed to fetch SCP data. Please check your network connection.",
          true
        );
        // setMessage('Failed to fetch SCP data. Please check your network connection.');
      }
    };
    // Fetch SCPM names based on the selected SCPM Level Number
    if (formdata.SCPM_SCPConfig_ID !== "") {
      fetchScpsByLevelNo();
    }
  }, [UM_CompanyGrpID, formdata.SCPM_SCPConfig_ID]);

  useEffect(() => {
    const fetchOPScpsByLevelNo = async () => {
      try {
        // Fetch SCPM names based on the selected SCPM Level Number
        const response = await axios.get(
          `${config.API_URL}/SCPM_SLP_OP/${UM_CompanyGrpID}/${formdata.SCPM_SCPConfig_ID}`
        );
        const data = response.data;
        if (response.status === 200) {
          if (data.SCPM_Names) {
            setOP_Scps(data.SCPM_Names);
            logAction(
              "fetchOPScpsByLevelNo(): Get SCP Outward party data from API "
            );
          } else {
            console.error("Invalid SCP API response:", data);
            showToast('error',
              "Failed to fetch SCP Outward Party data. Please check your network connection."
            );
            logAction(
              "fetchOPScpsByLevelNo(): Invalid SCP API response. Please check the server logs.",
              true
            );
            // setMessage('Invalid SCP API response. Please check the server logs.');
          }
        } else {
          console.error(
            "Error fetching SCP data. Server returned:",
            response.status
          );
          showToast('error',
            "Failed to fetch SCP Outward Party data. Please check your network connection."
          );
          logAction(
            "fetchOPScpsByLevelNo(): Error fetching SCP data. Please try again.",
            true
          );
          // setMessage('Error fetching SCP data. Please try again.');
        }
      } catch (error) {
        console.error("Failed to fetch SCP data:", error);
        showToast('error',
          "Failed to fetch SCP Outward Party data. Please check your network connection."
        );
        logAction(
          "fetchOPScpsByLevelNo(): Failed to fetch SCP data. Please check your network connection.",
          true
        );
        // setMessage('Failed to fetch SCP data. Please check your network connection.');
      }
    };
    // Fetch SCPM names based on the selected SCPM Level Number
    if (formdata.SCPM_SCPConfig_ID !== "") {
      fetchOPScpsByLevelNo();
    }
  }, [UM_CompanyGrpID, formdata.SCPM_SCPConfig_ID]);

  useEffect(() => {
    const fetchscpLevelNames = async () => {
      try {
        const response = await axios.get(
          `${config.API_URL}/SCPCONFIG_Name/${UM_CompanyGrpID}`
        );
        const data = response.data;
        setSCPLevelNo(data.SCP_LevelNo);
        console.log("SCP_LevelNo:", data?.SCP_LevelNo);
        console.log(data);
        if (response.status === 200) {
          if (data.length > 0) {
            // console.log(data)
            setscpLevelNames(data);
            setlevel(data);
            logAction(
              "fetchscpLevelNames(): Get SCP level name data from API "
            );
          } else {
            console.error("Invalid API response:", data);
            showToast('error',
              "Failed to fetch SCP Level Names. Please check your network connection."
            );
            logAction(
              " fetchscpLevelNames(): Invalid API response. Please check the server logs.",
              true
            );
            setMessage("Invalid API response. Please check the server logs.");
          }
        } else {
          console.error(
            "Error fetching SCP Level Names. Server returned:",
            response.status
          );
          showToast('error',
            "Failed to fetch SCP Level Names. Please check your network connection."
          );
          logAction(
            " fetchscpLevelNames():Error fetching SCP Level Names. Please try again.",
            true
          );
          setMessage("Error fetching SCP Level Names. Please try again.");
        }
      } catch (error) {
        console.error("Failed to fetch SCP Level Names:", error);
        showToast('error',
          "Failed to fetch SCP Level Names. Please check your network connection."
        );
        logAction(
          "fetchscpLevelNames(): Failed to fetch SCP data. Please check your network connection.",
          true
        );
        setMessage(
          "Failed to fetch SCP Level Names. Please check your network connection."
        );
      }
    };
    // ... (fetchScps remains unchanged)
    fetchscpLevelNames();
  }, [UM_CompanyGrpID]);

  const handleOPSubmit = (e) => {
    e.preventDefault();

    // Validate required fields
    if (
      scpAllowMutlipleParty.SCP_AllowMutliplePartyOutward !== 0 &&
      workingSelectedScps.length === 0
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        required: {
          ...prevErrors.required,
          SCPMO_OutwardParty: "*",
        },
      }));
      return;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        required: {
          ...prevErrors.required,
          SCPMO_OutwardParty: "",
        },
      }));
    }

    setSubmitted(true);
    setIsAddClicked(true);

    // Set the final selected scps to the working selection
    setSelectedScps(workingSelectedScps);

    // NEW: Disable the selected SCP IDs for outward party
    setDisabledOutwardScps([...disabledOutwardScps, ...workingSelectedScps]);

    setErrors((prevErrors) => ({ ...prevErrors, addButton: "" }));
    console.log("Selected SCPMO_OutwardParty data:", workingSelectedScps);
    logAction("handleOPSubmit(): Add SCP Outward party data ");
  };

  // Replace the handleSLPSubmit function:
  const handleSLPSubmit = (e) => {
    e.preventDefault();

    // Validate required fields
    if (
      scpAllowMutlipleParty.SCP_AllowMutliplePartySameLevelOutward !== 0 &&
      workingSelectedSameLevelParties.length === 0
    ) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        required: {
          ...prevErrors.required,
          SCPMSL_SameLevelParty: "*",
        },
      }));
      return;
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        required: {
          ...prevErrors.required,
          SCPMSL_SameLevelParty: "",
        },
      }));
    }

    setSubmittedSLP(true);
    setIsAddClickedSLP(true);

    // Set the final selected same level parties to the working selection
    setSelectedSameLevelParties(workingSelectedSameLevelParties);

    // NEW: Disable the selected SCP IDs for same level party
    setDisabledSameLevelScps([...disabledSameLevelScps, ...workingSelectedSameLevelParties]);

    setErrors((prevErrors) => ({ ...prevErrors, addButton: "" }));
    console.log("Selected SCPMSL_SameLevelParty data:", workingSelectedSameLevelParties);
    logAction("handleSLPSubmit(): Add same level party data ");
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };
    // Validate SCPM_Name
    if (!formdata.SCPM_Name) {
      newErrors.required.SCPM_Name = "*";
      valid = false;
    } else if (
      !/^[a-zA-Z0-9]$/.test(formdata.SCPM_Name[0]) ||
      !/^[a-zA-Z0-9]$/.test(formdata.SCPM_Name.slice(-1))
    ) {
      newErrors.other.SCPM_Name =
        "First and last character must be alphanumeric";
      valid = false;
    } else if (!/^[a-zA-Z0-9_\-. ]+$/.test(formdata.SCPM_Name)) {
      newErrors.other.SCPM_Name =
        "Please use only special characters like -, _, . and space";
      valid = false;
    } else if (/[_\-. ]{2,}/.test(formdata.SCPM_Name)) {
      newErrors.other.SCPM_Name =
        "Consecutive special characters are not allowed";
      valid = false;
    } else if (formdata.SCPM_Name.length > 45) {
      newErrors.other.SCPM_Name = "Maximum length is 45 characters";
      valid = false;
      logAction("validateForm():Maximum length is 45 characters", true);
    } else {
      newErrors.required.SCPM_Name = "";
      newErrors.other.SCPM_Name = "";
    }
    // Validate SCPM_Caption
    if (!formdata.SCPM_Caption) {
      newErrors.required.SCPM_Caption = "*";
      valid = false;
    } else if (
      !/^[a-zA-Z0-9]$/.test(formdata.SCPM_Caption[0]) ||
      !/^[a-zA-Z0-9]$/.test(formdata.SCPM_Caption.slice(-1))
    ) {
      newErrors.other.SCPM_Caption =
        "First and last character must be alphanumeric";
      valid = false;
    } else if (!/^[a-zA-Z0-9_\-. ]+$/.test(formdata.SCPM_Caption)) {
      newErrors.other.SCPM_Caption =
        "Please use only special characters like -, _, . and space";
      valid = false;
    } else if (/[_\-. ]{2,}/.test(formdata.SCPM_Caption)) {
      newErrors.other.SCPM_Caption =
        "Consecutive special characters are not allowed";
      valid = false;
    } else if (formdata.SCPM_Caption.length > 45) {
      newErrors.other.SCPM_Caption = "Maximum length is 45 characters";
      valid = false;
      logAction("validateForm():Maximum length is 45 characters", true);
    } else {
      newErrors.required.SCPM_Caption = "";
      newErrors.other.SCPM_Caption = "";
    }
    // Validate SCPM_Code
    if (!formdata.SCPM_Code) {
      newErrors.required.SCPM_Code = "*";
      valid = false;
    } else if (
      !/^[a-zA-Z0-9]$/.test(formdata.SCPM_Code[0]) ||
      !/^[a-zA-Z0-9]$/.test(formdata.SCPM_Code.slice(-1))
    ) {
      newErrors.other.SCPM_Code =
        "First and last character must be alphanumeric";
      valid = false;
    } else if (!/^[a-zA-Z0-9_\- ]+$/.test(formdata.SCPM_Code)) {
      newErrors.other.SCPM_Code =
        "Please use only special characters like -, _ and space";
      valid = false;
    } else if (/[_\- ]{2,}/.test(formdata.SCPM_Code)) {
      newErrors.other.SCPM_Code =
        "Consecutive special characters are not allowed";
      valid = false;
    } else if (formdata.SCPM_Code.length > 45) {
      newErrors.other.SCPM_Code = "Maximum length is 45 characters";
      valid = false;
      logAction("validateForm():Maximum length is 45 characters", true);
    } else {
      newErrors.required.SCPM_Code = "";
      newErrors.other.SCPM_Code = "";
    }
    // Validate SCPM_Status
    if (!formdata.SCPM_Status) {
      newErrors.required.SCPM_Status = "*";
      valid = false;
    } else {
      newErrors.required.SCPM_Status = "";
      newErrors.other.SCPM_Status = "";
    }
    // Validate SCPM_SCPConfig_ID
    if (!formdata.SCPM_SCPConfig_ID) {
      newErrors.required.SCPM_SCPConfig_ID = "*";
      valid = false;
    } else {
      newErrors.required.SCPM_SCPConfig_ID = "";
      newErrors.other.SCPM_SCPConfig_ID = "";
    }
    // Validate SCPM_ScanningMode
    if (!formdata.SCPM_ScanningMode) {
      newErrors.required.SCPM_ScanningMode = "*";
      valid = false;
    } else {
      newErrors.required.SCPM_ScanningMode = "";
      newErrors.other.SCPM_ScanningMode = "";
    }
    setErrors(newErrors);
    return valid;
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    setFormdata((prevData) => ({
      ...prevData,
      [name]: value.trimEnd(), // 🔥 only remove trailing space
    }));
  };
  const handleInput = (e) => {
    // Check if this is a react-select change event
    if (e && (e.value !== undefined || e === null)) {
      // This is for react-select SCPM_Status
      const name = "SCPM_Status";
      const value = e ? e.value : "";

      // Reset selected SCP Outward Party and SCP Same Level Party when SCP Level Name changes
      if (name === "SCPM_SCPConfig_ID") {
        setSelectedScps([]);
        setSelectedSameLevelParties([]);
        setSubmitted(false);
        setSubmittedSLP(false);
      }

      // Update form data
      setFormdata((prevFormData) => ({
        ...prevFormData,
        [name]: value
      }));

      // Run validation
      const newErrors = {
        required: { ...errors.required },
        other: { ...errors.other },
      };

      if (name === "SCPM_Status") {
        if (!value) {
          newErrors.required.SCPM_Status = "*";
        } else {
          newErrors.required.SCPM_Status = "";
          newErrors.other.SCPM_Status = "";
        }
      }

      setErrors(newErrors);
      return;
    }

    // Handle regular input changes
    const { name, value, type, checked } = e.target;

    // Reset selected SCP Outward Party and SCP Same Level Party when SCP Level Name changes
    if (name === "SCPM_SCPConfig_ID") {
      setSelectedScps([]);
      setSelectedSameLevelParties([]);
      setSubmitted(false);
      setSubmittedSLP(false);
    }

    // Update form data
    setFormdata((prevFormData) => {
      if (type === "checkbox") {
        const updatedScps = checked
          ? [...selectedScps, parseInt(value)]
          : selectedScps.filter((scp) => scp !== parseInt(value));

        setSelectedScps(updatedScps);
        return { ...prevFormData, [name]: updatedScps };
      } else {
        return { ...prevFormData, [name]: value };
      }
    });
    // Run validation for required fields and other specific fields
    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };
    // Validate SCPM_Name
    if (name === "SCPM_Name") {
      if (!value) {
        // newErrors.required.SCPM_Name = "*";
        newErrors.other.SCPM_Name = "";
        valid = false;
      } else if (
        value.length > 0 &&
        (!/^[a-zA-Z0-9]$/.test(value[0]) ||
          !/^[a-zA-Z0-9 ]$/.test(value[value.length - 1]))
      ) {
        newErrors.other.SCPM_Name = "First and last character must be alphanumeric";
        valid = false;
      } else if (!/^[a-zA-Z0-9_\-. ]+$/.test(value)) {
        newErrors.other.SCPM_Name =
          "Please use only special characters like -, _, . and space";
        valid = false;
        // } else if (/[_\-. ]{2,}/.test(value)) {
      } else if (/[_\-.]{2,}/.test(value) || / {2,}(?=\S)/.test(value)) {
        newErrors.other.SCPM_Name =
          "Consecutive special characters are not allowed";
        valid = false;
      } else if (value.length > 45) {
        newErrors.other.SCPM_Name = "Maximum length is 45 characters";
        valid = false;
      } else {
        newErrors.required.SCPM_Name = "";
        newErrors.other.SCPM_Name = "";
      }
    }
    // Validate SCPM_Caption
    if (name === "SCPM_Caption") {
      if (!value) {
        // newErrors.required.SCPM_Caption = "*";
        newErrors.other.SCPM_Caption = "";
        valid = false;
      } else if (
        value.length > 0 &&
        (!/^[a-zA-Z0-9]$/.test(value[0]) ||
          !/^[a-zA-Z0-9 ]$/.test(value[value.length - 1]))
      ) {
        newErrors.other.SCPM_Caption = "First and last character must be alphanumeric";
        valid = false;
      } else if (!/^[a-zA-Z0-9_\-. ]+$/.test(value)) {
        newErrors.other.SCPM_Caption =
          "Please use only special characters like -, _, . and space";
        valid = false;
        // } else if (/[_\-. ]{2,}/.test(value)) {
      } else if (/[_\-.]{2,}/.test(value) || / {2,}(?=\S)/.test(value)) {
        newErrors.other.SCPM_Caption =
          "Consecutive special characters are not allowed";
        valid = false;
      } else if (value.length > 45) {
        newErrors.other.SCPM_Caption = "Maximum length is 45 characters";
        valid = false;
      } else {
        newErrors.required.SCPM_Caption = "";
        newErrors.other.SCPM_Caption = "";
      }
    }

    // Validate SCPM_Code
    if (name === "SCPM_Code") {
      if (!value) {
        // newErrors.required.SCPM_Code = "*";
        newErrors.other.SCPM_Code = "";
        valid = false;
      } else if (
        value.length > 0 &&
        (!/^[a-zA-Z0-9]$/.test(value[0]) ||
          !/^[a-zA-Z0-9 ]$/.test(value[value.length - 1]))
      ) {
        newErrors.other.SCPM_Code =
          "First and last character must be alphanumeric";
        valid = false;
      } else if (!/^[a-zA-Z0-9_\- ]+$/.test(value)) {
        newErrors.other.SCPM_Code =
          "Please use only special characters like -, _ and space";
        valid = false;
        // } else if (/[_\- ]{2,}/.test(value)) {
      } else if (/[_\-]{2,}/.test(value) || / {2,}(?=\S)/.test(value)) {
        newErrors.other.SCPM_Code =
          "Consecutive special characters are not allowed";
        valid = false;
      } else if (value.length > 45) {
        newErrors.other.SCPM_Code = "Maximum length is 45 characters";
        valid = false;
      } else {
        newErrors.required.SCPM_Code = "";
        newErrors.other.SCPM_Code = "";
      }
    }
    // Validate SCPM_Status
    if (name === "SCPM_Status") {
      if (!value) {
        // newErrors.required.SCPM_Status = "*";
        valid = false;
      } else {
        newErrors.required.SCPM_Status = "";
        newErrors.other.SCPM_Status = "";
      }
    }
    // Validate SCPM_SCPConfig_ID
    if (name === "SCPM_SCPConfig_ID") {
      if (!value) {
        // newErrors.required.SCPM_SCPConfig_ID = "*";
        valid = false;
      } else {
        newErrors.required.SCPM_SCPConfig_ID = "";
        newErrors.other.SCPM_SCPConfig_ID = "";
      }
    }
    // Validate SCPM_ScanningMode
    if (name === "SCPM_ScanningMode") {
      if (!value) {
        // newErrors.required.SCPM_ScanningMode = "*";
        valid = false;
      } else {
        newErrors.required.SCPM_ScanningMode = "";
        newErrors.other.SCPM_ScanningMode = "";
      }
    }
    setErrors(newErrors);
    // If validation fails, do not proceed with form submission
    if (!valid) {
      return;
    }
  };

  const handleSelectChange = (selectedOption, fieldName) => {
    // Reset selected SCP Outward Party and SCP Same Level Party when SCP Level Name changes
    if (fieldName === "SCPM_SCPConfig_ID") {
      // Clear all related states
      setSelectedScps([]);
      setSelectedSameLevelParties([]);
      setWorkingSelectedScps([]);
      setWorkingSelectedSameLevelParties([]);
      setSubmitted(false);
      setSubmittedSLP(false);
      setIsAddClicked(false);
      setIsAddClickedSLP(false);

      // Clear the formdata fields
      setFormdata(prev => ({
        ...prev,
        SCPMO_OutwardParty: "",
        SCPMSL_SameLevelParty: "",
        [fieldName]: selectedOption ? selectedOption.value : ""
      }));

      // Also clear the arrays that store the names
      setoutwardscps([]);
      setsamelevel([]);

      // Reset disabled states
      setDisabledOutwardScps([]);
      setDisabledSameLevelScps([]);
    } else {
      // For other fields, just update normally
      const value = selectedOption ? selectedOption.value : "";
      setFormdata(prev => ({
        ...prev,
        [fieldName]: value
      }));
    }

    // Run validation
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };

    if (fieldName === "SCPM_SCPConfig_ID") {
      if (!selectedOption?.value) {
        newErrors.required.SCPM_SCPConfig_ID = "*";
      } else {
        newErrors.required.SCPM_SCPConfig_ID = "";
        newErrors.other.SCPM_SCPConfig_ID = "";
      }
    } else if (fieldName === "SCPM_ScanningMode") {
      if (!selectedOption?.value) {
        newErrors.required.SCPM_ScanningMode = "*";
      } else {
        newErrors.required.SCPM_ScanningMode = "";
        newErrors.other.SCPM_ScanningMode = "";
      }
    }

    setErrors(newErrors);
  };
  // Format scpLevelNames for react-select
  const scpLevelOptions = scpLevelNames.map(item => ({
    value: item.SCP_ID,
    label: item.SCP_LevelName
  }));
  const handleCheckboxChange = async (e) => {
    const { name, value, checked } = e.target;
    const scpId = parseInt(value);
    console.log(" name, value, checked", name, value, checked);
    if (!isNaN(scpId)) {
      // Use name to determine which state variable to update
      if (name === "SCPMO_OutwardParty") {
        const updatedScps = checked
          ? [...workingSelectedScps, scpId]
          : workingSelectedScps.filter((scp) => scp !== scpId);
        setWorkingSelectedScps(updatedScps);

        // ✅ CLEAR REQUIRED ERROR IF ANY SELECTED
        if (updatedScps.length > 0) {
          setErrors((prev) => ({
            ...prev,
            required: {
              ...prev.required,
              SCPMO_OutwardParty: "",
            },
          }));
        }
        const item = await op_scps.find((scp) => scp.SCPM_ID === scpId);
        if (checked) {
          setoutwardscps([...outwardscps, item.SCPM_Name]);
        } else {
          setoutwardscps(outwardscps.filter((scp) => scp !== item.SCPM_Name));
        }
      } else if (name === "SCPMSL_SameLevelParty") {
        const updatedSameLevelParties = checked
          ? [...workingSelectedSameLevelParties, scpId]
          : workingSelectedSameLevelParties.filter((scp) => scp !== scpId);
        setWorkingSelectedSameLevelParties(updatedSameLevelParties);
        // ✅ CLEAR REQUIRED ERROR
        if (updatedSameLevelParties.length > 0) {
          setErrors((prev) => ({
            ...prev,
            required: {
              ...prev.required,
              SCPMSL_SameLevelParty: "",
            },
          }));
        }
        const item = await scps.find((scp) => scp.SCPM_ID === scpId);
        if (checked) {
          setsamelevel([...samelevel, item.SCPM_Name]);
        } else {
          setsamelevel(samelevel.filter((scp) => scp !== item.SCPM_Name));
        }
      }

      // Reset the ADD button state since changes were made
      if (name === "SCPMO_OutwardParty") {
        setIsAddClicked(false);
      } else if (name === "SCPMSL_SameLevelParty") {
        setIsAddClickedSLP(false);
      }
    }
  };
  console.log(samelevel);

  const handleSelectAll = (e, type) => {
    const isChecked = e.target.checked;

    if (type === "SCPMO_OutwardParty") {
      // enabled ids (not disabled / not already added)
      const enabledIds = op_scps
        .filter((scp) => !disabledOutwardScps.includes(scp.SCPM_ID))
        .map((scp) => scp.SCPM_ID);

      if (isChecked) {
        // Add enabled ids to current selection (avoid duplicates)
        const newSelection = Array.from(new Set([...workingSelectedScps, ...enabledIds]));
        setWorkingSelectedScps(newSelection);

        // Add enabled names to outward scps names, preserving existing ones
        const enabledNames = op_scps
          .filter((s) => enabledIds.includes(s.SCPM_ID))
          .map((s) => s.SCPM_Name);
        setoutwardscps(Array.from(new Set([...outwardscps, ...enabledNames])));
      } else {
        // Remove only enabled ids from current selection — keep disabled ones intact
        const newSelection = workingSelectedScps.filter((id) => !enabledIds.includes(id));
        setWorkingSelectedScps(newSelection);

        // Remove enabled names from outwardscps names but keep others
        const enabledNameSet = new Set(
          op_scps.filter((s) => enabledIds.includes(s.SCPM_ID)).map((s) => s.SCPM_Name)
        );
        setoutwardscps(outwardscps.filter((name) => !enabledNameSet.has(name)));
      }

      setIsAddClicked(false);
      setErrors((prev) => ({
        ...prev,
        required: {
          ...prev.required,
          SCPMO_OutwardParty: "",
        },
      }));
    } else if (type === "SCPMSL_SameLevelParty") {
      // enabled ids (not disabled / not already added)
      const enabledIds = scps
        .filter((scp) => !disabledSameLevelScps.includes(scp.SCPM_ID))
        .map((scp) => scp.SCPM_ID);

      if (isChecked) {
        const newSelection = Array.from(new Set([...workingSelectedSameLevelParties, ...enabledIds]));
        setWorkingSelectedSameLevelParties(newSelection);

        const enabledNames = scps
          .filter((s) => enabledIds.includes(s.SCPM_ID))
          .map((s) => s.SCPM_Name);
        setsamelevel(Array.from(new Set([...samelevel, ...enabledNames])));
      } else {
        const newSelection = workingSelectedSameLevelParties.filter((id) => !enabledIds.includes(id));
        setWorkingSelectedSameLevelParties(newSelection);

        const enabledNameSet = new Set(
          scps.filter((s) => enabledIds.includes(s.SCPM_ID)).map((s) => s.SCPM_Name)
        );
        setsamelevel(samelevel.filter((name) => !enabledNameSet.has(name)));
      }

      setIsAddClickedSLP(false);
      setErrors((prev) => ({
        ...prev,
        required: {
          ...prev.required,
          SCPMSL_SameLevelParty: "",
        },
      }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    // Validation for ADD buttons
    if (
      workingSelectedScps.length > 0 &&
      workingSelectedSameLevelParties.length > 0 &&
      !isAddClicked &&
      !isAddClickedSLP
    ) {
      showToast(
        "error",
        "Please click the ADD button for both SCP Outward Party and SCP Same Level Party."
      );
      return;
    }

    if (workingSelectedScps.length > 0 && !isAddClicked) {
      showToast("error", "Please click the ADD button for SCP Outward Party.");
      return;
    }

    if (workingSelectedSameLevelParties.length > 0 && !isAddClickedSLP) {
      showToast("error", "Please click the ADD button for SCP Same Level Party.");
      return;
    }

    const checkDuplicatePayload = {
      SCPM_Name: formdata.SCPM_Name,
      SCPM_Caption: formdata.SCPM_Caption,
      SCPM_Code: formdata.SCPM_Code,
      SCPM_CompanyID: UM_CompanyID,
    };

    try {
      // ✅ Disable form immediately
      setIsLoading(true);

      // ---------------- DUPLICATE CHECK ----------------
      const duplicateResponse = await axios.post(
        `${config.API_URL}/check_duplicate`,
        checkDuplicatePayload,
        { headers: { "Content-Type": "application/json" } }
      );

      const { duplicateExists, message } = duplicateResponse.data;

      if (duplicateExists) {
        setIsLoading(false);
        showToast("error", message);
        logAction("tried to save duplicate data", true);
        return;
      }

      // ---------------- INSERT PAYLOAD ----------------
      const insertPayload = {
        SCPM_Name: formdata.SCPM_Name,
        SCPM_Caption: formdata.SCPM_Caption,
        SCPM_Code: formdata.SCPM_Code,
        SCPM_SCPConfig_ID: formdata.SCPM_SCPConfig_ID,
        SCPM_Status: formdata.SCPM_Status,
        SCPM_ScanningMode: formdata.SCPM_ScanningMode,
        SCPMO_OutwardParty: selectedScps,
        SCPMSL_SameLevelParty: selectedSameLevelParties,
        SCPM_CompanyGrpID: UM_CompanyGrpID,
        SCPM_CompanyID: UM_CompanyID,
      };

      const response = await axios.post(
        `${config.API_URL}/scp_master`,
        insertPayload,
        { headers: { "Content-Type": "application/json" } }
      );

      // ---------------- SUCCESS ----------------
      if (response.status === 200) {
        logAction(
          `handleSubmit(): SCP : ${formdata.SCPM_Name} saved successfully.`
        );

        const details = {
          AUTR_Message: "SCP Added",
          AUTR_AuditType: "insert",
          AUTR_NewValue: formdata.SCPM_Name,
          AUTR_OldValue: "-",
        };

        let id = await audittrailpost(details);

        const logAuditTrail = (message, id, newValue, oldValue) => {
          const details = {
            AUTRN_ParamererName: message,
            AUTRN_ID: id,
            AUTRN_NewValue: newValue,
            AUTRN_OldValue: oldValue,
          };
          audittransection(details);
        };

        logAuditTrail("SCP_Name", id, formdata.SCPM_Name, "-");
        logAuditTrail("SCPM_Caption", id, formdata.SCPM_Caption, "-");
        logAuditTrail("SCPM_Code", id, formdata.SCPM_Code, "-");

        if (formdata.SCPM_ScanningMode === 1) {
          logAuditTrail("SCPM_ScanningMode", id, "Vendor", "-");
        } else {
          logAuditTrail("SCPM_ScanningMode", id, "Product", "-");
        }

        if (formdata.SCPM_Status === 1) {
          logAuditTrail("SCPM_Status", id, "Active", "-");
        } else {
          logAuditTrail("SCPM_Status", id, "Inactive", "-");
        }

        outwardscps.forEach((id1) => {
          logAuditTrail("SCP Outward Party", id, id1, "-");
        });

        samelevel.forEach((id2) => {
          logAuditTrail("SCP Same Level Party", id, id2, "-");
        });

        // ✅ Toast controls when form re-enables
        showToast(
          "success",
          `SCP : ${formdata.SCPM_Name} saved successfully.`,
          {
            autoClose: 3000,
            onClose: () => {
              handleCancel();      // clear form
              setIsLoading(false); // enable form AFTER toast closes
            },
          }
        );

        setErrors((prev) => ({ ...prev, add: "" }));
      } else {
        setIsLoading(false);
        showToast(
          "error",
          `SCP : ${formdata.SCPM_Name} could not be saved successfully.`
        );
        logAction("Error came saving data", true);
      }
    } catch (err) {
      setIsLoading(false);
      showToast(
        "error",
        `SCP : ${formdata.SCPM_Name} could not be saved successfully.`
      );
      logAction("Error came saving data", true);
      console.error("Network error:", err);
      setMessage(
        "Failed to insert data. Please check your network connection."
      );
    }

    setErrors((prev) => ({ ...prev, addButton: "" }));
  };


  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm()) {
  //     // If validation fails, do not proceed with form submission
  //     return;
  //   }

  //   // Check if Add button was clicked for selected checkboxes
  //   if (
  //     workingSelectedScps.length > 0 &&
  //     workingSelectedSameLevelParties.length > 0 &&
  //     !isAddClicked &&
  //     !isAddClickedSLP
  //   ) {
  //     // Case: Neither ADD buttons were clicked for both SCP and Same Level Party
  //     showToast('error',
  //       "Please click the ADD button for both SCP Outward Party and Same Level Party."
  //     );
  //   } else if (workingSelectedScps.length > 0 && !isAddClicked) {
  //     // Case: ADD button for SCP Outward Party was not clicked
  //     showToast('error', "Please click the ADD button for SCP Outward Party.");
  //   } else if (workingSelectedSameLevelParties.length > 0 && !isAddClickedSLP) {
  //     // Case: ADD button for Same Level Party was not clicked
  //     showToast('error', "Please click the ADD button for Same Level Party.");
  //   } else {
  //     const checkDuplicatePayload = {
  //       SCPM_Name: formdata.SCPM_Name,
  //       SCPM_Caption: formdata.SCPM_Caption,
  //       SCPM_Code: formdata.SCPM_Code,
  //       SCPM_CompanyID: UM_CompanyID,
  //     };

  //     try {
  //       const duplicateResponse = await axios.post(
  //         `${config.API_URL}/check_duplicate`,
  //         checkDuplicatePayload,
  //         {
  //           headers: { "Content-Type": "application/json" },
  //         }
  //       );

  //       const { duplicateExists, message } = duplicateResponse.data;
  //       if (duplicateExists) {
  //         showToast('error', message);
  //         logAction("tried to save duplicate data", true);
  //         return;
  //       }
  //       setIsLoading(true);

  //       const insertPayload = {
  //         SCPM_Name: formdata.SCPM_Name,
  //         SCPM_Caption: formdata.SCPM_Caption,
  //         SCPM_Code: formdata.SCPM_Code,
  //         SCPM_SCPConfig_ID: formdata.SCPM_SCPConfig_ID,
  //         SCPM_Status: formdata.SCPM_Status, // Assuming SCPM_Status is already an integer
  //         SCPM_ScanningMode: formdata.SCPM_ScanningMode, // Assuming SCPM_ScanningMode is already an integer
  //         SCPMO_OutwardParty: selectedScps,
  //         SCPMSL_SameLevelParty: selectedSameLevelParties,
  //         SCPM_CompanyGrpID: UM_CompanyGrpID,
  //         SCPM_CompanyID: UM_CompanyID,
  //       };
  //       setIsLoading(true);

  //       const response = await axios.post(
  //         `${config.API_URL}/scp_master`,
  //         insertPayload,
  //         {
  //           headers: { "Content-Type": "application/json" },
  //         }
  //       );

  //       if (response.status === 200) {
  //         // logAction("handleSubmit(): Data saved successfully.");
  //         logAction(
  //           `handleSubmit(): SCP : ${formdata.SCPM_Name} saved successfully.`
  //         );

  //         const details = {
  //           AUTR_Message: "SCP Added",
  //           AUTR_AuditType: "insert",
  //           AUTR_NewValue: formdata.SCPM_Name,
  //           AUTR_OldValue: "-",
  //         };
  //         let id = await audittrailpost(details);

  //         const logAuditTrail = (message, id, newValue, oldValue) => {
  //           const details = {
  //             AUTRN_ParamererName: message,
  //             AUTRN_ID: id,
  //             AUTRN_NewValue: newValue,
  //             AUTRN_OldValue: oldValue,
  //           };
  //           audittransection(details);
  //         };

  //         logAuditTrail("SCP_Name", id, formdata.SCPM_Name, "-");
  //         logAuditTrail("SCPM_Caption", id, formdata.SCPM_Caption, "-");
  //         logAuditTrail("SCPM_Code", id, formdata.SCPM_Code, "-");
  //         function findNameAndSubById(data, id1) {
  //           const item = data.find((obj) => obj.SCP_ID === id1);
  //           console.log(item);

  //           if (item) {
  //             //   return { name: item.SCP_LevelName};
  //             logAuditTrail("SCPM_SCPConfig_ID", id, item.SCP_LevelName, "-");
  //             console.log(item.SCP_LevelName);
  //           } else {
  //             return null; // or handle the case where the id is not found
  //           }
  //         }

  //         console.log(level);
  //         findNameAndSubById(level, formdata.SCPM_SCPConfig_ID);
  //         //   console.log(result)
  //         // logAuditTrail( "SCPM_SCPConfig_ID",id,formdata.SCPM_SCPConfig_ID,'-');
  //         // logAuditTrail( "SCPM_ScanningMode",id,formdata.SCPM_ScanningMode,'-');
  //         if (formdata.SCPM_ScanningMode === 1) {
  //           logAuditTrail("SCPM_ScanningMode", id, "Vendor", "-");
  //         } else {
  //           logAuditTrail("SCPM_ScanningMode", id, "Product", "-");
  //         }

  //         if (formdata.SCPM_Status === 1) {
  //           logAuditTrail("SCPM_Status", id, "Active", "-");
  //         } else {
  //           logAuditTrail("SCPM_Status", id, "Inactive", "-");
  //         }

  //         outwardscps.forEach((id1) => {
  //           // logAuditTrail(`In ${formdata.SCPM_Name}, SCP Outward Party: ${id1} added`, id1, "-");
  //           logAuditTrail("SCP Outward Party", id, id1, "-");
  //         });

  //         samelevel.forEach((id2) => {
  //           // logAuditTrail(`In ${formdata.SCPM_Name}, SCP Same Level Party: ${id2} added`, id2, "-");
  //           logAuditTrail("SCP Same Level Party", id, id2, "-");
  //         });
  //         showToast('success', `SCP : ${formdata.SCPM_Name} saved successfully.`, {
  //           onClose: () => {
  //             handleCancel();
  //             setIsLoading(false);
  //           }
  //         });
  //         setErrors((prevErrors) => ({ ...prevErrors, add: "" }));
  //       } else {
  //         setIsLoading(false);

  //         showToast('error',
  //           `SCP : ${formdata.SCPM_Name} could not be saved successfully.`
  //         );
  //         logAction("Error came saving data", true);
  //         console.error("Error in saving Data:", response.statusText);
  //       }
  //     } catch (err) {
  //       setIsLoading(false);

  //       showToast('error',
  //         `SCP : ${formdata.SCPM_Name} could not be saved successfully.`
  //       );
  //       logAction("Error came saving data", true);
  //       console.error("Network error:", err);
  //       setMessage(
  //         "Failed to insert data. Please check your network connection."
  //       );
  //     }
  //     setErrors((prevErrors) => ({ ...prevErrors, addButton: "" }));
  //     setIsLoading(false);

  //   }
  //   // setIsLoading(false);

  // };
  console.log("SCPM_SCPConfig_ID", formdata.SCPM_SCPConfig_ID);

  const handleCancel = () => {
    logAction("handleCancel():started");

    // Get default scanning mode based on available options
    let defaultScanningMode = "";
    if (scanningModeOptions.length > 0) {
      // Sort options to ensure Vendor comes first
      const sortedOptions = [...scanningModeOptions].sort((a, b) =>
        parseInt(a.value) - parseInt(b.value)
      );

      // Set default based on available options
      if (sortedOptions.length === 1) {
        // If only one option, select it
        defaultScanningMode = sortedOptions[0].value;
      } else if (sortedOptions.length > 1) {
        // If multiple options, leave it blank (empty string)
        defaultScanningMode = "";
      }
    } else {
      // If no options, leave it blank
      defaultScanningMode = "";
    }

    console.log("SCPM_SCPConfig_ID-----", formdata.SCPM_SCPConfig_ID);
    setFormdata({
      SCPM_Name: "",
      SCPM_Caption: "",
      SCPM_Code: "",
      SCPM_SCPConfig_ID: "",
      SCPM_Status: 1,
      SCPM_ScanningMode: defaultScanningMode, // Use the calculated default
      SCPMO_OutwardParty: "",
      SCPMSL_SameLevelParty: "",
      SCPM_CompanyGrpID: UM_CompanyGrpID,
      SCPM_CompanyID: UM_CompanyID,
    });

    setErrors({
      required: initialData,
      other: initialData,
    });
    setScpAllowMutlipleParty({
      SCP_AllowMutliplePartyOutward: "",
      SCP_AllowMutliplePartySameLevel: ""
    })
    // Clear selectedScps
    setScps([]);
    setOP_Scps([]);
    setSelectedScps([]);
    setSelectedSameLevelParties([]);
    setWorkingSelectedScps([]); // NEW: Clear working selection
    setWorkingSelectedSameLevelParties([]); // NEW: Clear working selection
    setSubmittedSLP(false);
    setDisabledOutwardScps([]); // NEW: Reset disabled outward SCP IDs
    setDisabledSameLevelScps([]); // NEW: Reset disabled same level SCP IDs
    setSubmitted(false);
    setMessage("");
    setIsAddClicked(false); // Reset the state when resetting the form
    setIsAddClickedSLP(false); // Reset the state when resetting the form
    logAction("handleCancel():ended form is reset successfully.");

  };
  const logAction = async (action, isError = false) => {
    console.log(`${isError ? "[ERROR] " : ""}${action}`);
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "SCP-Master:",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  const handleClearOP = () => {
    setConfirmationMessage(
      "Are you sure you want to clear all SCP Outward Parties ?"
    );
    setOnConfirmAction(() => clearOP);
    setShowConfirmation(true);
  };

  const clearOP = () => {
    // NEW: Re-enable all outward SCP IDs when clearing
    setDisabledOutwardScps([]);
    setSelectedScps([]);
    setWorkingSelectedScps([]); // NEW: Clear working selection
    setSubmitted(false);
    setIsAddClicked(false);
    logAction("clearOP(): Clear all SCP Outward party ");
  };

  const handleClearSLP = () => {
    setConfirmationMessage(
      "Are you sure you want to clear all SCP Same Level Parties ?"
    );
    setOnConfirmAction(() => clearSLP);
    setShowConfirmation(true);
  };
  const clearSLP = () => {
    // NEW: Re-enable all same level SCP IDs when clearing
    setDisabledSameLevelScps([]);
    setSelectedSameLevelParties([]);
    setWorkingSelectedSameLevelParties([]); // NEW: Clear working selection
    setSubmittedSLP(false);
    setIsAddClickedSLP(false);
    logAction("clearSLP(): Clear all SCP Same level party ");
  };

  const handleDeleteSCP = (scpId) => {
    const scpName = scps.find((scp) => scp.SCPM_ID === scpId)?.SCPM_Name || "";
    setConfirmationMessage(
      `Are you sure you want to remove this SCP Same Level Party : ${scpName} ?`
    );
    setOnConfirmAction(() => () => deleteSCP(scpId));
    setShowConfirmation(true);
    if (selectedSameLevelParties.length > 0) {
      setIsAddClickedSLP(false);
    }
  };

  const deleteSCP = (scpId) => {
    const updatedSameLevelParties = selectedSameLevelParties.filter(
      (scp) => scp !== scpId
    );
    setSelectedSameLevelParties(updatedSameLevelParties);
    // NEW: Re-enable the deleted SCP ID for same level party
    setDisabledSameLevelScps(disabledSameLevelScps.filter(id => id !== scpId));
    // NEW: Also uncheck it in the working selection
    setWorkingSelectedSameLevelParties(
      workingSelectedSameLevelParties.filter(id => id !== scpId)
    );

    logAction("deleteSCP(): SCP Same level delete by id ");

    if (selectedSameLevelParties.length === 1) {
      setSubmittedSLP(false);
    }
  };

  const handleDeleteOP = (scpId) => {
    const scpName =
      op_scps.find((scp) => scp.SCPM_ID === scpId)?.SCPM_Name || "";
    setConfirmationMessage(
      `Are you sure you want to remove SCP Outward Party : ${scpName} ?`
    );
    setOnConfirmAction(() => () => deleteOP(scpId));
    setShowConfirmation(true);
    if (selectedScps.length > 0) {
      setIsAddClicked(false);
    }
  };

  const deleteOP = (scpId) => {
    const updatedScps = selectedScps.filter((scp) => scp !== scpId);
    setSelectedScps(updatedScps);
    // NEW: Re-enable the deleted SCP ID for outward party
    setDisabledOutwardScps(disabledOutwardScps.filter(id => id !== scpId));
    // NEW: Also uncheck it in the working selection
    setWorkingSelectedScps(
      workingSelectedScps.filter(id => id !== scpId)
    );
    logAction("deleteOP(): SCP Outward party delete by id ");

    if (selectedScps.length === 1) {
      setSubmitted(false);
    }
  };

  const handleConfirm = () => {
    if (onConfirmAction) {
      onConfirmAction();
    }
    setShowConfirmation(false);
    setConfirmationMessage("");
    setOnConfirmAction(null);
  };

  const handleCancelConfirm = () => {
    setShowConfirmation(false);
    setConfirmationMessage("");
    setOnConfirmAction(null);
  };
  return (
    <React.Fragment>
      <ToastContainer
        style={{
          marginTop: "73px",
          fontSize: "14px",
          width: "40%",
        }}
      />
      {isLoading && (
        <div style={{
          position: 'fixed', // Sit on top of the page content
          left: 0,
          top: 0,
          width: '100%', // Full width
          height: '100%', // Full height

          zIndex: 1000 // Sit on top of the other elements
        }} />
      )}
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="main_container">
          <h3 className="formHeading">SCP Master</h3>
          <div className="row">
            {/* <div className="form-section"> */}
            <div className="col-md-6">
              <label>
                SCP Name{" "}
                <span className="text-danger  ">
                  {errors.required.SCPM_Name}
                </span>
              </label>
              <input
                type="tel"
                name="SCPM_Name"
                className="form-input"
                value={formdata.SCPM_Name}
                onChange={handleInput}
                onBlur={handleBlur}
                maxLength={45}
              />
              <div className="text-danger  ">
                {errors.other.SCPM_Name}
              </div>
            </div>
            <div className="col-md-6">
              <label>
                SCP Caption Name{" "}
                <span className="text-danger  ">
                  {errors.required.SCPM_Caption}
                </span>
              </label>
              <input
                type="tel"
                name="SCPM_Caption"
                className="form-input"
                value={formdata.SCPM_Caption}
                onChange={handleInput}
                onBlur={handleBlur}
                maxLength={45}
              />
              <div className="text-danger  ">
                {errors.other.SCPM_Caption}
              </div>
            </div>
            <div className="col-md-6">
              <label>
                SCP Code{" "}
                <span className="text-danger  ">
                  {errors.required.SCPM_Code}
                </span>
              </label>
              <input
                type="tel"
                name="SCPM_Code"
                className="form-input"
                value={formdata.SCPM_Code}
                onChange={handleInput}
                onBlur={handleBlur}
                maxLength={45}
              />
              <div className="text-danger  ">
                {errors.other.SCPM_Code}
              </div>
            </div>
            <div className="col-md-6">
              <label>
                SCP Level Name{" "}
                <span className="text-danger  ">
                  {errors.required.SCPM_SCPConfig_ID}
                </span>
              </label>
              <div className="select-container">
                <Select
                  key={`scp-level-${formdata.SCPM_SCPConfig_ID}`} // Add this key
                  name="SCPM_SCPConfig_ID"
                  options={scpLevelOptions}
                  value={scpLevelOptions.find(option => option.value === formdata.SCPM_SCPConfig_ID)}
                  onChange={(selectedOption) => handleSelectChange(selectedOption, "SCPM_SCPConfig_ID")}
                  placeholder="--Select--"
                  onMenuOpen={() => handleSelectOpen("SCPM_SCPConfig_ID")}
                  onMenuClose={handleSelectClose}
                />
                <div className="icon-container_list myList">
                  {isSelectOpen === "SCPM_SCPConfig_ID" ? (
                    <IoCaretUpOutline />
                  ) : (
                    <IoCaretDownOutline />
                  )}
                </div>
              </div>
              <div className="text-danger  ">
                {errors.other.SCPM_SCPConfig_ID}
              </div>
            </div>
            <div className="col-md-6">
              <label>
                Scanning mode{" "}
                <span className="text-danger  ">
                  {errors.required.SCPM_ScanningMode}
                </span>
              </label>
              <div className="select-container">
                <Select
                  name="SCPM_ScanningMode"
                  options={scanningModeOptions.length > 0 ? scanningModeOptions : defaultScanningModeOptions}
                  value={
                    formdata.SCPM_ScanningMode
                      ? (scanningModeOptions.length > 0 ? scanningModeOptions : defaultScanningModeOptions)
                        .find(option => option.value === formdata.SCPM_ScanningMode)
                      : null  // IMPORTANT: Set to null when empty
                  }
                  onChange={(selectedOption) => {
                    handleInput({
                      target: {
                        name: "SCPM_ScanningMode",
                        value: selectedOption ? selectedOption.value : ""
                      }
                    });
                  }}
                  placeholder="--Select--"
                  isDisabled={scanningModeLoading}
                  isLoading={scanningModeLoading}
                  onMenuOpen={() => handleSelectOpen("SCPM_ScanningMode")}
                  onMenuClose={handleSelectClose}
                />
                <div className="icon-container_list myList">
                  {isSelectOpen === "SCPM_ScanningMode" ? (
                    <IoCaretUpOutline />
                  ) : (
                    <IoCaretDownOutline />
                  )}
                </div>
              </div>
              <div className="text-danger  ">
                {errors.other.SCPM_ScanningMode}
              </div>
            </div>
            <div className="col-md-6">
              <label>
                {" "}
                Status{" "}
                <span className="text-danger  ">
                  {errors.required.SCPM_Status}
                </span>
              </label>
              <div className="select-container">
                <Select
                  name="SCPM_Status"
                  options={statusOptions}
                  value={statusOptions.find(option => option.value === formdata.SCPM_Status)}
                  onChange={(selectedOption) => handleInput(selectedOption)}
                  placeholder="--Select--"
                  onMenuOpen={() => handleSelectOpen("SCPM_Status")}
                  onMenuClose={handleSelectClose}
                  isSearchable={false}

                />
                <div className="icon-container_list myList">
                  {isSelectOpen === "SCPM_Status" ? (
                    <IoCaretUpOutline />
                  ) : (
                    <IoCaretDownOutline />
                  )}
                </div>
              </div>
              <div className="text-danger  ">
                {errors.other.SCPM_Status}
              </div>
            </div>
            {/* </div> */}

            <div className="col-md-12 mt-2">
              <div className="row">
                {scpAllowMutlipleParty.SCP_AllowMutliplePartyOutward !== 0 && (
                  <div className="col-md-6">
                    <label>
                      SCP Outward Party
                      <span className="text-danger  ">
                        {errors.required.SCPMO_OutwardParty}
                      </span>

                    </label>
                    <div className="form-checked">
                      <div>
                        <input
                          type="checkbox"
                          className="form-check-input ms-0"
                          id="selectAllOutward"

                          // checked={selectedScps.length === op_scps.length}
                          checked={workingSelectedScps.length > 0 && workingSelectedScps.length === op_scps.length}
                          onChange={(e) =>
                            handleSelectAll(e, "SCPMO_OutwardParty")
                          }
                          // disabled={op_scps.length === 0} // Disable if no options
                          // disabled={op_scps.length === 0 || workingSelectedScps.length === op_scps.length} 
                          disabled={op_scps.length === 0 || (isAddClicked && workingSelectedScps.length === op_scps.length)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="selectAllOutward"
                        >
                          Select All
                        </label>
                      </div>
                      {op_scps.map((scp) => (

                        <div key={scp.SCPM_ID}>
                          <input
                            className="form-check-input ms-0"
                            type="checkbox"
                            name="SCPMO_OutwardParty"
                            onChange={handleCheckboxChange}
                            // checked={selectedScps.includes(scp.SCPM_ID)}
                            checked={workingSelectedScps.includes(scp.SCPM_ID)} // Use working selection
                            value={scp.SCPM_ID}
                            disabled={disabledOutwardScps.includes(scp.SCPM_ID)} // NEW: Disable if already added
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`flexCheckDefault${scp.SCPM_ID}`}
                          >
                            {scp.SCPM_Name}
                            {disabledOutwardScps.includes(scp.SCPM_ID)} {/* NEW: Show added status */}
                          </label>
                        </div>
                      ))}
                    </div>
                    <div className="text-danger  ">
                      {errors.other.SCPMO_OutwardParty}
                    </div>
                    <button
                      className="scp_party_add_btn"
                      type="submit"
                      onClick={handleOPSubmit}
                    >
                      ADD <span>{errors.addButton}</span>
                    </button>
                  </div>
                )}
                {scpAllowMutlipleParty.SCP_AllowMutliplePartySameLevelOutward !==
                  0 && (
                    <div className="col-md-6">
                      <label>
                        SCP Same Level Party
                        <span className="text-danger  ">
                          {errors.required.SCPMSL_SameLevelParty}
                        </span>
                      </label>
                      <div className="form-checked">
                        <div>
                          <input
                            type="checkbox"
                            className="form-check-input  ms-0"
                            id="selectAllSLP"
                            checked={
                              // selectedSameLevelParties.length === scps.length
                              workingSelectedSameLevelParties.length > 0 &&
                              workingSelectedSameLevelParties.length === scps.length
                            }

                            onChange={(e) =>
                              handleSelectAll(e, "SCPMSL_SameLevelParty")
                            }
                            // disabled={scps.length === 0} // Disable if no options
                            disabled={scps.length === 0 || (isAddClickedSLP && workingSelectedSameLevelParties.length === scps.length)} // Disable when all are checked
                          />
                          <label
                            className="form-check-label"
                            htmlFor="selectAllSLP"
                          >
                            Select All
                          </label>
                        </div>
                        {scps.map((scp) => (
                          <div key={scp.SCPM_ID}>
                            <input
                              className="form-check-input  ms-0"
                              type="checkbox"
                              name="SCPMSL_SameLevelParty"
                              onChange={handleCheckboxChange}
                              // checked={selectedSameLevelParties.includes(scp.SCPM_ID)}
                              checked={workingSelectedSameLevelParties.includes(scp.SCPM_ID)} // Use working selection
                              value={scp.SCPM_ID}
                              disabled={disabledSameLevelScps.includes(scp.SCPM_ID)} // NEW: Disable if already added
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`flexCheckDefaultSameLevel${scp.SCPM_ID}`}
                            >
                              {scp.SCPM_Name}
                              {disabledSameLevelScps.includes(scp.SCPM_ID)} {/* NEW: Show added status */}
                            </label>
                          </div>
                        ))}
                      </div>
                      <div className="text-danger  ">
                        {errors.other.SCPMSL_SameLevelParty}
                      </div>
                      <button
                        className="scp_party_add_btn"
                        type="submit"
                        onClick={handleSLPSubmit}
                      >
                        ADD <span>{errors.addButton}</span>
                      </button>
                    </div>
                  )}

                <div className="col-md-6 mt-3">
                  {submitted && selectedScps.length > 0 && (
                    <>
                      <div className="table_div">
                        <table className="tableClass_scp">
                          <thead>
                            <tr>
                              <th style={{ width: '80px' }}>Sr. No.</th>
                              <th> SCP Upper and Lower Level</th>
                              <th style={{ width: '80px' }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedScps.map((scp, index) => (
                              <tr key={index + 1}>
                                <td>{index + 1}</td>
                                <td>
                                  {
                                    op_scps.find((item) => item.SCPM_ID === scp)
                                      ?.SCPM_Name
                                  }
                                </td>
                                <td>
                                  <img
                                    src={Icon5}
                                    alt="trash"
                                    className="delete_btn"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDeleteOP(scp)}
                                    title="Remove"
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div>
                        {submitted && selectedScps.length > 1 && (

                          <button
                            className="m-2 scp_party_clearall_btn"
                            type="button"
                            onClick={handleClearOP}
                            disabled={!(submitted && selectedScps.length > 1)}
                            style={{
                              opacity: submitted && selectedScps.length > 1 ? 1 : 0.5,
                              cursor: submitted && selectedScps.length > 1 ? "pointer" : "not-allowed",
                            }}
                          >
                            CLEAR ALL
                          </button>

                        )}
                      </div>
                    </>
                  )}
                </div>
                <div className="col-md-6 mt-3">
                  {submittedSLP && selectedSameLevelParties.length > 0 && (
                    <>
                      <div className="table_div">
                        <table className="tableClass_scp ">
                          <thead>
                            <tr>
                              <th style={{ width: '80px' }}>Sr. No.</th>
                              <th> Same Level Party</th>
                              <th style={{ width: '80px' }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {selectedSameLevelParties.map((scp, index) => (
                              <tr key={index + 1}>
                                <td>{index + 1}</td>
                                <td>
                                  {
                                    scps.find((item) => item.SCPM_ID === scp)
                                      ?.SCPM_Name
                                  }
                                </td>
                                <td>
                                  <img
                                    src={Icon5}
                                    alt="trash"
                                    className="delete_btn"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDeleteSCP(scp)}
                                    title="Remove"
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {submittedSLP && selectedSameLevelParties.length > 1 && (

                        <button
                          className="m-2 scp_party_clearall_btn"
                          type="button"
                          onClick={handleClearSLP}
                          disabled={!(submittedSLP && selectedSameLevelParties.length > 1)}
                          style={{
                            opacity: submittedSLP && selectedSameLevelParties.length > 1 ? 1 : 0.5,
                            cursor: submittedSLP && selectedSameLevelParties.length > 1 ? "pointer" : "not-allowed",
                          }}
                        >
                          CLEAR ALL
                        </button>

                      )}

                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button-container">
          <button className="save_btn" type="submit">
            SAVE
          </button>
          <button className="reset_btn" type="button" onClick={handleCancel}>
            RESET
          </button>
          <Link to={`/dashboard/scpmlist`} className=" list_btn" type="button">
            LIST
          </Link>
        </div>

        {/* Confirmation Popup */}
        {showConfirmation && (
          <div className="popup_overlay">
            <div className="resetpopup">
              <h1>:: User Confirmation ::</h1>
              <h4>{confirmationMessage}</h4>
              <div className="popup_btn_container">
                <button className="yes_btn " onClick={handleConfirm}>
                  Yes
                </button>
                <button className="no_btn " onClick={handleCancelConfirm}>
                  No
                </button>
              </div>
            </div>
          </div>
        )}
      </form>
    </React.Fragment>
  );
}
export default SCPMaster;
